import React from 'react'

import { FeedbackFormView } from './FeedbackFormView'
import { StagedFeedbackForm } from './StagedFeedbackForm'
import { useFeedbackForm } from './useFeedbackForm'

import { ReporterFeedbackPayload } from '@/queries/events'
import { Event, EventFeedback, Reporter } from '@/types'
import { isWithSessionAssistant } from '@/utils/parrot'

type Props = {
  event: Event
  reporter: Reporter
  feedback: ReporterFeedbackPayload | undefined
  onSubmit: () => void
}

// Single entry point for the CR feedback form, used wherever the form is rendered
// (ongoing / waiting / past).
// Session Assistant events render the Staged Form (all steps); everything else gets
// the plain feedback view. Each branch is its own component so hooks stay unconditional.
export const FeedbackForm: React.FC<Props> = props => {
  return isWithSessionAssistant(props.event) ? (
    <StagedFeedbackForm {...props} />
  ) : (
    <NonStagedFeedbackForm {...props} />
  )
}

// Owns its own (non-staged) form instance and renders the plain feedback view.
const NonStagedFeedbackForm: React.FC<Props> = ({
  event,
  reporter,
  feedback,
  onSubmit,
}) => {
  const bundle = useFeedbackForm({
    event,
    reporter,
    events_feedbacks: feedback?.events_feedbacks as EventFeedback[],
    steps: feedback?.steps, // passthrough: preserve saved step state even when not editing it
    sa: feedback?.sa, // passthrough: preserve saved scripted-field state
    onSubmit,
  })

  return <FeedbackFormView event={event} {...bundle} />
}
